import { style } from 'typestyle'
export const mt20 = style({ marginTop: '20px' })
